import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { builder } from "@builder.io/react";
import { getLocaleId, getSessionCountry, isE2E } from "@faire/web--source/builder/BuilderComponents/builderUtils";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import isChromatic from "chromatic/isChromatic";
import { useLocation } from "react-router-dom";
export var useBuilderContentQuery = function(modelName, contentOptions) {
    var _getLocaleId;
    var pathname = useLocation().pathname;
    var userCountry = getSessionCountry();
    var _getLocaleId_replace;
    // e.g. "en-US", "fr-FR", "de-DE"
    // if not set, use "Default" as the default locale
    var locale = (_getLocaleId_replace = (_getLocaleId = getLocaleId()) === null || _getLocaleId === void 0 ? void 0 : _getLocaleId.replace("_", "-")) !== null && _getLocaleId_replace !== void 0 ? _getLocaleId_replace : "Default";
    var defaultUserAttributes = {
        locale: locale,
        urlPath: pathname,
        userCountry: userCountry
    };
    var enabled = !isE2E() && !isChromatic();
    return useQuery({
        queryKey: [
            modelName,
            defaultUserAttributes,
            locale,
            contentOptions,
            contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.userAttributes,
            contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.options
        ],
        queryFn: function() {
            return builder.get(modelName, _object_spread_props(_object_spread({}, contentOptions), {
                userAttributes: _object_spread({}, defaultUserAttributes, contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.userAttributes),
                options: _object_spread({
                    // locale is required, otherwise text will not appear
                    locale: locale
                }, contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.options)
            })).promise();
        },
        placeholderData: keepPreviousData,
        staleTime: Infinity,
        enabled: enabled
    });
};
